module.exports = __webpack_public_path__ + "static/media/Global4000.e76da43c.png";